import { trackEvent } from '~src/tracking';

/**
 * Apply spell check fix
 * @param {fabric.Textbox} textbox
 * @param {object} match
 * @param {string} replacement
 */
export function applySpellCheckFix(textbox, match, replacement) {
  const text = textbox.text;
  const before = text.substring(0, match.offset);
  const after = text.substring(match.offset + match.length);

  const originalWord = text.substring(
    match.offset,
    match.offset + match.length
  );
  textbox.text = before + replacement + after;

  // Mark popup as interacted
  if (window._spellCheckPopupInteracted !== undefined) {
    window._spellCheckPopupInteracted = true;
  }

  // Track the spell check fix
  trackEvent('Spell Check Fix Applied', {
    original_word: originalWord,
    replacement_word: replacement,
    error_type: match.rule?.id || 'unknown',
    suggestion_index: match.replacements?.indexOf(replacement) ?? -1,
    total_suggestions: match.replacements?.length || 0,
  });

  // Clear spell check results as text has changed
  if (textbox.clearSpellCheckResults) {
    textbox.clearSpellCheckResults();
  }

  // Fire text changed event
  textbox.fire('changed');
  if (window.canvas && typeof window.canvas.fire === 'function') {
    window.canvas.fire('text:changed', { target: textbox });
    if (typeof window.canvas.requestRenderAll === 'function') {
      window.canvas.requestRenderAll();
    }
  }
}
